import LabeledField from '../../components/LabeledField';
import { useTextareaStyles } from './Textarea.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Textarea = ({
  name,
  value,
  label,
  labelLayout,
  placeholder,
  required,
  isDisabled = false,
  onChange
}) => {
  const {
    textareaStyle
  } = useTextareaStyles({
    isDisabled
  });
  const inputId = `textarea-${name}`;
  const handleChange = e => {
    onChange(name, e.target.value);
  };
  return /*#__PURE__*/_jsx(LabeledField, {
    htmlFor: inputId,
    label: label,
    required: required,
    labelLayout: labelLayout,
    children: /*#__PURE__*/_jsx("textarea", {
      id: inputId,
      value: value,
      placeholder: placeholder,
      required: required,
      disabled: isDisabled,
      onChange: handleChange,
      style: textareaStyle
    })
  });
};
export default Textarea;